import {DATASOURCE} from 'Constants'

const initialState = {
    data: [],
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case DATASOURCE.PACKET_DATA_T.RESET:
            return {
                ...state,
                loading: false,
                data: []
            };
        case DATASOURCE.PACKET_DATA_T.LOADING:
            return {
                ...state,
                loading: true,
                data: []
            };
        case DATASOURCE.PACKET_DATA_T.KEY:
            return {
                ...state,
                loading: false,
                data: process(action.data)
            };
        default:
            return state;
    }
}

function process(data) {
    const inbound = {name: "To RealConnect", data: []};
    const outbound = {name: "From RealConnect", data: []};
    const output = [inbound, outbound];
    if (!data.aggregations || !data.aggregations.lossPerMinute ||
        !data.aggregations.lossPerMinute.buckets || data.aggregations.lossPerMinute.buckets.length <= 1) {
        return output;
    }
    const buckets = data.aggregations.lossPerMinute.buckets;
    let maxCumPktLoss = {atx: 0, arx: 0, pvtx: 0, pvrx: 0, cvtx: 0, cvrx: 0}
    buckets.forEach(bucket => {
        const maxPktLoss = {atx: 0, arx: 0, pvtx: 0, pvrx: 0, cvtx: 0, cvrx: 0}
        for (const key of Object.keys(maxPktLoss)) {
            maxPktLoss[key] = Math.max(maxCumPktLoss[key], bucket[key].value);
        }
        const pktLossOutboundDer = maxPktLoss.atx - maxCumPktLoss.atx +
                                   maxPktLoss.pvtx - maxCumPktLoss.pvtx +
                                   maxPktLoss.cvtx - maxCumPktLoss.cvtx;

        const pktLossInboundDer = maxPktLoss.arx - maxCumPktLoss.arx +
                                  maxPktLoss.pvrx - maxCumPktLoss.pvrx +
                                  maxPktLoss.cvrx - maxCumPktLoss.cvrx;

        inbound.data.push([bucket.key, pktLossInboundDer]);
        outbound.data.push([bucket.key, pktLossOutboundDer]);
        maxCumPktLoss = maxPktLoss;
    });
    return output;
}
